import dynamicMerchants from './dynamicMerchants';

export default dynamicMerchants;
